import { render, staticRenderFns } from "./StoryRepresentativeListPage.vue?vue&type=template&id=42e8b252&scoped=true&"
import script from "./StoryRepresentativeListPage.vue?vue&type=script&lang=js&"
export * from "./StoryRepresentativeListPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42e8b252",
  null
  
)

export default component.exports